<script lang="ts">
import * as Sentry from '@sentry/vue'
import { defineComponent, h, onErrorCaptured, ref } from 'vue'

import { useI18n } from '@/lib/i18n'

export default defineComponent({
  name: 'ErrorBoundary',
  setup(_, { slots }) {
    const { t } = useI18n()

    const hasErrorRef = ref(false)

    onErrorCaptured((error) => {
      if (!hasErrorRef.value) {
        Sentry.captureException(error)
      }
      hasErrorRef.value = true
      return false
    })

    function goHome() {
      window.location.href = '/'
    }

    return () => {
      if (!hasErrorRef.value) {
        return slots.default ? slots.default() : null
      }
      return h(
        'div',
        {
          'class': 'error-boundary-fallback',
          'data-test-id': 'error-boundary-fallback',
        },
        [
          h('div', { class: 'error-boundary-fallback__content' }, [
            h('h2', t('errorBoundary.title')),
            h('p', t('errorBoundary.description')),
            h(
              'button',
              {
                'type': 'button',
                'class': 'error-boundary-fallback__home-button',
                'data-test-id': 'error-boundary-home-button',
                'onClick': goHome,
              },
              t('errorBoundary.goHome'),
            ),
          ]),
        ],
      )
    }
  },
})
</script>

<style lang="scss">
.error-boundary-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  width: 100%;
  padding: 2rem;
  background: #fbfbfb;

  &__content {
    max-width: 32rem;
    text-align: center;

    h2 {
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
    }

    p {
      color: #555;
      margin-bottom: 1.5rem;
    }
  }

  &__home-button {
    display: inline-block;
    padding: 0.625rem 1.25rem;
    border-radius: 0.5rem;
    background: var(--color-primary, #3936bd);
    color: #fff;
    font-weight: 500;
    border: none;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
